import { PLAYER_PORTALS_MODELS } from '@r-and-a-shared-ui/common-kontent-client';
import { getPrefixedMembershipInternalLink } from '@r-and-a-shared-ui/utils';
import { getFirstMappedLinkedItemOrDefault } from './utils';

export type BurgerMenuItem =
  | {
      title: string;
      href: string;
      internal: boolean;
      codename?: string;
      children?: never;
    }
  | {
      title: string;
      children: BurgerMenuItem[];
      roles?: [];
    };

const parseLink = (link: any) => {
  const internal = !link.elements?.href.value;

  const internalHref = getPrefixedMembershipInternalLink(
    link?.elements?.internal_page?.linkedItems?.[0]?.system?.type,
    link?.elements?.internal_page?.linkedItems?.[0]?.elements?.url_slug?.value,
  );

  const href = link.elements?.href?.value || internalHref;
  const roles = internal
    ? link?.elements?.internal_page?.linkedItems?.[0]?.elements?.roles?.value
    : [];
  return {
    title: link.elements.title.value ?? link.system?.name ?? 'Untitled',
    href,
    internal,
    codename: !href ? link?.system?.codename : undefined,
    roles,
  };
};

const parseMenu = (menu: any) => {
  return menu.elements?.menu_items?.linkedItems?.reduce(
    (acc: BurgerMenuItem[], item: any) => {
      if (item.system.type === 'link') {
        acc.push(parseLink(item));
        return acc;
      }
      if (item.system.type === 'player_portals_menu') {
        acc.push({
          title: item.elements?.title?.value,
          children: parseMenu(item),
          roles: item.elements?.roles?.value ?? [],
        });
        return acc;
      }
    },
    [],
  );
};

export const player_portals_menu = (item: PLAYER_PORTALS_MODELS.Menu) => {
  const result = parseMenu(item);

  return {
    title: item.elements?.title?.value,
    menuItems: result,
    idCard: getFirstMappedLinkedItemOrDefault(
      item.elements?.burger_menu_id_card,
    ),
  };
};

export default player_portals_menu;
